import { render, staticRenderFns } from "./InputTime.vue?vue&type=template&id=bec8dd16"
import script from "./InputTime.vue?vue&type=script&lang=ts"
export * from "./InputTime.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports